import { Swiper } from 'swiper';

export default CardSlider = () => {
  const sections = document.querySelectorAll('.section-card-slider');

  for (const section of sections) {
    const slider = section.querySelector('.swiper');

    const swiper = new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        576: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
        1400: {
          slidesPerView: 4,
        },
      },
    });
  }
};
